import React, {useMemo} from 'react';
import ManagementOverviewAChartX from './ManagementOverviewAChartX';
import {PerformanceRatioSummary, ReferencePeriod} from '../types/ManagementOverviewReport.types';
import {
    buildGaugeChartOption,
    MANAGEMENT_OVERVIEW_GAUGE_HEIGHT_PX,
} from '../utils/managementOverviewChartOptions';
import {buildManagementOverviewChartId} from '../utils/managementOverviewChartIds';
import type {AChartXProps} from '@atiautomacao/ati-ui-library';

interface PerformanceRatioGaugePanelProps {
    stationId: number;
    performanceRatio: PerformanceRatioSummary;
    referencePeriod: ReferencePeriod;
    onChartReady?: (chartId: string) => void;
}

const PerformanceRatioGaugePanel: React.FC<PerformanceRatioGaugePanelProps> = ({
    stationId,
    performanceRatio,
    referencePeriod,
    onChartReady,
}) => {
    const periodAside = `${referencePeriod.month} ${referencePeriod.year}`;
    const asChartOption = (option: object): AChartXProps['option'] => option as AChartXProps['option'];

    const basicOption = useMemo(
        () => asChartOption(buildGaugeChartOption('PR Básico', performanceRatio.basic)),
        [performanceRatio.basic]
    );
    const normalizedOption = useMemo(
        () => asChartOption(buildGaugeChartOption('PR Normalizado', performanceRatio.normalized)),
        [performanceRatio.normalized]
    );

    return (
        <aside className="management-overview-gauge-panel avoid-break">
            <div className="management-overview-gauge-panel__header">
                <span>Performace Ratio</span>
                <span>{periodAside}</span>
            </div>
            <div className="management-overview-gauges__stack">
                <div className="management-overview-gauge">
                    <div
                        className="management-overview-chart"
                        style={{ height: MANAGEMENT_OVERVIEW_GAUGE_HEIGHT_PX }}
                    >
                        <ManagementOverviewAChartX
                            chartId={buildManagementOverviewChartId(stationId, 'gauge-basic')}
                            option={basicOption}
                            onChartReady={onChartReady}
                        />
                    </div>
                    <p className="management-overview-gauge__caption">PR Básico</p>
                    <p className="management-overview-gauge__values">
                        Realizado: {performanceRatio.basic.actualPercent.toFixed(2)}% — Esperado:{' '}
                        {performanceRatio.basic.expectedPercent.toFixed(2)}%
                    </p>
                </div>
                <div className="management-overview-gauge">
                    <div
                        className="management-overview-chart"
                        style={{ height: MANAGEMENT_OVERVIEW_GAUGE_HEIGHT_PX }}
                    >
                        <ManagementOverviewAChartX
                            chartId={buildManagementOverviewChartId(stationId, 'gauge-normalized')}
                            option={normalizedOption}
                            onChartReady={onChartReady}
                        />
                    </div>
                    <p className="management-overview-gauge__caption">PR Normalizado</p>
                    <p className="management-overview-gauge__values">
                        Realizado: {performanceRatio.normalized.actualPercent.toFixed(2)}% — Esperado:{' '}
                        {performanceRatio.normalized.expectedPercent.toFixed(2)}%
                    </p>
                </div>
            </div>
        </aside>
    );
};

export default PerformanceRatioGaugePanel;
